// Copyright (c) 2020-2026 Life and Soft

import "react-app-polyfill/ie9"; // For IE 9-11 support
import "react-app-polyfill/stable";
import { createStore, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { jwtDecode } from "jwt-decode";

import "./polyfill";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import setAuthToken from "./utils/setAuthToken";
import { setCurrentUser } from "./actions/authActions";
import rootReducer from "./reducers";

const initialState = {};

const middleware = [thunk];

const store = createStore(
  rootReducer,
  initialState,
  compose(
    applyMiddleware(...middleware),
    (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__()) ||
      compose,
  ),
);

// Check for token to keep user logged in
if (localStorage.jwtToken) {
  // Set auth token header auth
  const token = localStorage.jwtToken;
  setAuthToken(token);

  // Decode token and get user info and exp
  const tokenDecoded = jwtDecode(token);
  // Set user and isAuthenticated
  store.dispatch(setCurrentUser(tokenDecoded));
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
